import { render, staticRenderFns } from "./VxCellMoney.vue?vue&type=template&id=c3d10578&"
import script from "./VxCellMoney.vue?vue&type=script&lang=js&"
export * from "./VxCellMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports